import { render, staticRenderFns } from "./Form13ProcessHeader.vue?vue&type=template&id=0f01c051&scoped=true"
import script from "./Form13ProcessHeader.vue?vue&type=script&lang=ts"
export * from "./Form13ProcessHeader.vue?vue&type=script&lang=ts"
import style0 from "./Form13ProcessHeader.vue?vue&type=style&index=0&id=0f01c051&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f01c051",
  null
  
)

export default component.exports